import { IconProps } from "@/data/types"

export default function SearchIcon({ width=24, height=24, color='#A58760', className }: IconProps) {
  return (
    <div className={className}>
      <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.875 18.75C15.2242 18.75 18.75 15.2242 18.75 10.875C18.75 6.52576 15.2242 3 10.875 3C6.52576 3 3 6.52576 3 10.875C3 15.2242 6.52576 18.75 10.875 18.75Z" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16.4438 16.4434L21.0001 20.9996" stroke={color} strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    </div>
  )
}